export const TRADITIONAL_PLAN_PAYMENT_INTENT_SUCCESS = 'TRADITIONAL_PLAN_PAYMENT_INTENT_SUCCESS';
export const TRADITIONAL_PLAN_PAYMENT_INTENT_ACTION = 'TRADITIONAL_PLAN_PAYMENT_INTENT_ACTION';
export const TRADITIONAL_PLAN_PAYMENT_INTENT = 'TRADITIONAL_PLAN_PAYMENT_INTENT';
export const TRADITIONAL_RENEW_PLAN_PAYMENT_ACTION = 'TRADITIONAL_RENEW_PLAN_PAYMENT_ACTION';
export const TRADITIONAL_RENEW_PLAN_PAYMENT_SUCCESS= 'TRADITIONAL_RENEW_PLAN_PAYMENT_SUCCESS';